let ancillaryMenuLoaded = false

class AncillaryMenu extends window.BAO.CustomElement() {
  connectedCallback () {
    if (ancillaryMenuLoaded) return

    window.BAO.sectionRenderer
      .fetch('header', `${window.Shopify.routes.root}?view=ancillary-menu`)
      .then(res => {
        ancillaryMenuLoaded = true

        const newDOM = window.BAO.sectionRenderer.convertToDOM(res.header)
        const myself = newDOM.querySelector(this.localName)

        this.externalEls.menu.element.outerHTML = myself.outerHTML
      })
      .catch(() => {})
  }
}

if (!customElements.get('ancillary-menu')) {
  customElements.define('ancillary-menu', AncillaryMenu)
}
